import React, { useImperativeHandle, useRef } from "react";
import { RCCHookToast, RCCRefModalProps } from "react-common-components";
import { useForm } from "react-hook-form";
import ModalTreeHierarchyMaps from "src/components/ModalTreeHierarchyMaps";
import { useTranslation } from "src/context/Translations/context";
import { MapsHierarchyTypes } from "src/pages/StrategicPlanning/Maps/interface";
import { standardErrorMessages } from "src/utils/errors";

export interface IRefSelectObjectiveModals{
    openModalSelectObjective: () => void;
}

export interface IModalSelectObjective {
    subtitle?: string;
    onCallbackSelectObjective?: (objs: string[] | undefined) => void;
}

const ModalSelectObjective: React.ForwardRefRenderFunction<IRefSelectObjectiveModals, IModalSelectObjective> = ({
	subtitle,
	onCallbackSelectObjective
}, ref) => {
	const { translate } = useTranslation(); 
	const { addToast } = RCCHookToast();

	const modalSelectObjectives = useRef<RCCRefModalProps>(null);

	const { 
		handleSubmit, 
		register,
		reset,
		unregister
	} = useForm();

	const onSubmit = (data: any) => {
		try{
			const hierarchyObj = data[`selectedItens-${MapsHierarchyTypes.OBJECTIVES}`];
			if(!hierarchyObj){
				addToast({
					color: "yellow",
					description: translate("Selecione um objetivo para ser adicionado"),
					title: translate("Atenção")
				});
				return;
			}

			const selectedItens = Object.keys(hierarchyObj).map((key) => hierarchyObj[key]).filter((item: any) => typeof item === "string");

			if(selectedItens.length <= 0){
				addToast({
					color: "yellow",
					description: translate("Selecione um objetivo para ser adicionado"),
					title: translate("Atenção")
				});
				return;
			}

			modalSelectObjectives.current?.closeModal();

			if(onCallbackSelectObjective)
				onCallbackSelectObjective(selectedItens as string[]);

		}catch(err){
			standardErrorMessages(err, translate("Erro ao adicionar objetivos"), addToast);
			modalSelectObjectives.current?.closeModal();
		}
	};

	const openModalSelectObjective = () => {
		reset();
		modalSelectObjectives.current?.openModal();
	};

	useImperativeHandle(ref, () => ({
		openModalSelectObjective
	}));

	return (
		<ModalTreeHierarchyMaps 
			ref={modalSelectObjectives}
			title={translate("Adicionar Objetivo")}
			subtitle={`${translate("Projeto")}: ${subtitle}`}
			footer= {{
				showSaveButton: true,
				buttonLoadingText: translate("Carregando"),
				saveButtonText: translate("Adicionar"),
				cancelButtonText: translate("Cancelar")
			}}
			onSubmit={handleSubmit(onSubmit)}
			register={register}
			unregister={unregister}
			checkLevelHierarchy = {MapsHierarchyTypes.OBJECTIVES}
			lastLevelHierarchy={MapsHierarchyTypes.OBJECTIVES} 
		/>
	);
};

export default React.forwardRef(ModalSelectObjective);
